import React, { useMemo } from 'react';
import { Radio, RadioGroup } from '@chakra-ui/react';
import { Colors, Text } from '@mercator-gcp/grout';
import { FlexColumn } from 'components/layout/FlexColumn/FlexColumn';
import { FlexRow } from 'components/layout/FlexRow';
import { EmailFrequency } from 'types';

interface FrequencySelectorProps {
  emailFrequency: EmailFrequency;
  handleFrequencyChange: (nextValue: EmailFrequency) => void;
}

const radioGroupStyles = {
  '.chakra-radio__input': {
    background: Colors.ArmyGreen900,
  },
  '.chakra-radio__control': {
    background: Colors.White,
    borderColor: Colors.ArmyGreen300,
    width: '18px',
    height: '18px',
  },
  '.chakra-radio__control:hover': {
    background: Colors.White,
    borderColor: Colors.ForestGreen900,
  },
  '.chakra-radio__control[data-checked]': {
    borderColor: Colors.ForestGreen900,
    color: Colors.ForestGreen900,
  },
  '.chakra-radio__control[data-checked]:hover': {
    borderColor: Colors.ForestGreen900,
    color: Colors.ForestGreen900,
  },
};

const radioButtonsStyles = {
  gap: 'padding_8',
};

const buttonContainer = {
  gap: 'padding_8',
};

const FrequencySelector: React.FC<FrequencySelectorProps> = ({
  emailFrequency,
  handleFrequencyChange,
}) => {
  const settingLabel = useMemo(() => {
    switch (emailFrequency) {
      case EmailFrequency.WEEKLY:
        return 'Sent on Mondays at 7AM local time';
      case EmailFrequency.MONTHLY:
        return 'Sent 1st of the month at 7AM local time';
      case EmailFrequency.DAILY:
      default:
        return 'Sent daily at 7AM local time';
    }
  }, [emailFrequency]);

  return (
    <FlexColumn sx={buttonContainer}>
      <RadioGroup
        onChange={handleFrequencyChange}
        value={String(emailFrequency)}
        sx={radioGroupStyles}
      >
        <FlexRow sx={radioButtonsStyles}>
          <Radio value={String(EmailFrequency.DAILY)} colorScheme="whiteAlpha">
            <Text>Daily</Text>
          </Radio>
          <Radio value={String(EmailFrequency.WEEKLY)} colorScheme="whiteAlpha">
            <Text>Weekly</Text>
          </Radio>
          <Radio value={String(EmailFrequency.MONTHLY)} colorScheme="whiteAlpha">
            <Text>Monthly</Text>
          </Radio>
        </FlexRow>
      </RadioGroup>
      <Text.Small color={Colors.TextQuiet}>{settingLabel}</Text.Small>
    </FlexColumn>
  );
};

export default FrequencySelector;
